<template>
  <div class="detail_news">
    <div>
        <img src="@/assets/img/about1.png" alt="" style="width:100%;height:auto;">
    </div>
    <div class="detail_main">
        <h1>{{detail.title}}</h1>
        <h4 class="stitle">
            <p>发布日期：2021-01-01</p>
            <p>浏览量：614</p>
             
        </h4>
        <p class="htmltexts" v-html="detail.content"></p>
    </div>
  </div>
</template>
<script>
export default {
    data(){
        return {
            detail:{},
            title: "端午节放假通知",
            date: "2021-6-14",
            hs:'<h5 style="text-align:justify;"><p><font size="2">&nbsp; &nbsp; 端午节是我国优秀传统节日，2021年6月12日至6月14日，我公司端午节放假</font></p>&nbsp; &nbsp; 五月初五是我国端午节，也称重五节、端阳节、天中节、午日节、草蒲节、解粽节、浴兰节、女儿节。俗称五月节，冀豫等地还称为“五月单”。按照古代干支纪年，五月为午月，五月初五即午月午日，所以称之重五或重午。端为首次、第一，所以称端午。五为阳数，所以也称端阳。此日接近一年的一半，所以又称天中节。古时，是日少女须配戴灵符，头答榴花，极尽美艳之姿，所以也称女儿节。唐初该节名称多混用。由于唐玄宗生于八月初五，为了避讳，就正式将此节定名为端午。&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;<img src="http://139.9.87.34:99/park_app_image/20201105175716.jpg"/><br/>&nbsp; &nbsp; 许多大节都是吉月吉日，唯有此节在古人眼里是恶月恶日。这与夏商周时期的夏至节驱邪避毒活动有关，也与龙图腾崇拜等习俗有关。随着历史的发展，此节越来越成为纪念先贤的重要节日，伍子青、屈原、孝女曹娥等都是端午祭祀的对象。有关节俗，南方江河水系较多的地方要赛龙舟、饮雄黄酒、吃粽子。北方水系少，也普遍要吃粽子。抗日战争时期，郭沫若曾在端午节联络一批爱国诗人成立了诗人节。 　</h5><h5 style="text-align:justify;">　建国后诗人们还经常举行端午诗会，抒发热爱祖国、热爱家乡的壮丽情怀。作为国家非物质文化遗产保护项目，端午节在人们心目中日益凸显。2005年春，韩国抢注端午祭引起了国人的关注和愤慨，也因此产生了强烈的民族文化自尊和自觉，对此节和所有民族节日更为重视。</h5><h5 style="text-align:justify;">　除汉族外，现在还有满族、蒙古族、藏族、苗族、舍族、彝族、锡伯族、朝鲜族、土家族等28个数民族都过端午节，但风俗有异，名称也有所不同。</h5>'
        }
    },
    mounted(){
        this.initdetail()
    },
    methods: {
        initdetail(){
            console.log(JSON.parse(this.$route.query.detail),"详情")
            if(JSON.parse(this.$route.query.detail)){
                this.detail = JSON.parse(this.$route.query.detail)
            }
        }
    }
}
</script>
<style lang="less" scoped>
.detail_news {
    .detail_main {
        width: 1200px;
        margin: 0 auto;
        padding: 20px 0;
        .htmltexts {
            text-align: justify;
            padding-bottom: 100px;
            img {
                text-align: center;
            }
        }
        .stitle {
            width: 50%;
            margin: 0 auto;
            display: flex;
            justify-content: space-evenly;
        }
    }
}
</style>